import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { StorageService } from './storage.service';
import { DeliveryService } from './delivery.service';
import { ApiService } from './api.service';

import { Customer } from '../models/customer';

import { Utils } from '../helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
	current: Customer;
  clientInfo: string;

  constructor(private storage: StorageService,
    private deliveryServ: DeliveryService,
    private http: HttpClient,
    private api: ApiService) {
  	this.current = storage.getInSession('current_customer');
    if(this.current)
      this._getClientInfo(this.current);
  }

  setCustomer(customer: Customer) {
    this._getClientInfo(customer).subscribe(res => {
      this.storage.storeInLocal('current_customer', customer);
      this.current = customer;
    }, err => {
      this.storage.storeInLocal('current_customer', customer);
      this.current = customer;
    });
  }
  getCustomer(): Customer {
    this.current = this.storage.getInLocal('current_customer');
    Customer.fixSurname(this.current);

    if(Utils.isIOS() && !!this.current) {
      this.current.coords = null;
    }

  	return this.current;
  }

  createCustomer(customer: Customer, store: boolean = true, selectedDistrict: {bairro: string, valor: string}): Observable<any> {
    let auxName = customer.name;
    customer.name = customer.name + ' ' + customer.surname;

    return new Observable((obs) => {
      this.api.create('customers', {
        customer: customer
      }).subscribe(
        res => {
          customer.surname = '';
          customer.id = res.customer.id;
          customer.token = res.customer.token;
          if(store) {
            this.setCustomer(customer);
            this.deliveryServ.selectDistrictObj(selectedDistrict);
          }
          setTimeout(() => {
            obs.next(customer);
            obs.complete();
          }, 300);
          
        },
        err => {
          customer.name = auxName;
          alert("Erro ao salvar seus dados");
          obs.error(err);
          obs.complete();
          console.log(err);
        }
      );
    });
  }

  updateCustomer(token: string, customer: Customer): Observable<any> {
    return new Observable((obs) => {
      this.api.req('customers', {
        customer: customer,
        token: token
      }, {
        collection: 'customer_update'
      }, 'post').subscribe(
        res => {
          this.setCustomer(res.customer);
          obs.next(res);
        },
        err => {
          console.log(err);
          obs.error(err);
        },
        () => { obs.complete(); }
      );
    });
  }

  getToken(name = null, surname = null, phone = null): Observable<Customer> {
    return new Observable((obs) => {
      if(!this.current && phone == null) {
        obs.error(null);
        obs.complete();
        return;
      }

      if(name && surname && phone) {
        this.current = <Customer> {
          name: name,
          surname: surname,
          phone: phone
        };
      }
      
      this.api.index('customers', {
        name: this.current.name + (this.current.surname ? " " + this.current.surname : ""),
        phone: this.current.phone
      }, {
        collection: 'get_token'
      }).subscribe(
        res => {
          if(res.customer == null) {
            obs.error(null);
            obs.complete();
            return;
          }
          
          this.current = res.customer;
          Customer.fixSurname(this.current);
          this.setCustomer(this.current);
          setTimeout(() => { // timeout so the browser can store user's data.
            obs.next(res.customer);
            obs.complete();
          }, 50);
        },
        err => {
          console.log(err);
          obs.error(err);
          obs.complete();
        }
      );
    })
  }

  getMode(): 'delivery'|'pickup' {
    return this.current.address ? 'delivery' : 'pickup';
  }

  private _getClientInfo(customer: Customer): Observable<any> {
    return new Observable<any>((obs) => {
      this.http.get("https://www.cloudflare.com/cdn-cgi/trace", {
        responseType: 'text'
      }).subscribe(
        res => {
          let data = res.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
          data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';

          customer.additional_info = data;
          obs.next(data);
        },
        err => {
          console.log(err);
          obs.error(err);
        },
        () => {
          obs.complete();
        }
      );
    });
  }
}
